import { render } from "./BannerFixedSlot.vue?vue&type=template&id=6ef080f4&scoped=true"
import script from "./BannerFixedSlot.vue?vue&type=script&lang=js"
export * from "./BannerFixedSlot.vue?vue&type=script&lang=js"

import "./BannerFixedSlot.vue?vue&type=style&index=0&id=6ef080f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef080f4"]])

export default __exports__